import React from 'react';
import get from 'lodash.get';
import { PropTypes } from 'prop-types';
import FormElements from '../../../FormElements/FormElements';
import { DrawerContainer } from './styles';
import NoResults from './NoResults';
import ErroredResults from './ErroredResults';
import PropertyItemsAssembly from './PropertyItemsAssembly';
import { FiltersContainerWrapper } from '../styles';
import { QUERY_BOOKING_BYPASS_REASON } from '../../../../gql/Map/gql';
import mutationError from '../../../../lib/mutationError';
import FiltersContainer from './FiltersContainer';
import Drawer from '../../Drawer';
import DrawerSelect from '../../Drawer/DrawerSelect';
import { parseDateRangeWithMoment } from '../../../../lib/RoomSchedules';

// This array maps given options (index) to arguments needed for graphql query
const mapSelectValuestoIndex = [
  ['Relevance', 'ASC'],
  ['Alphabetical', 'ASC'],
  ['Alphabetical', 'DESC'],
  ['Distance', 'ASC'],
  ['Distance', 'DESC'],
  ['Price', 'ASC'],
  ['Price', 'DESC']
];

const BookingBypassTypes = {
  Cx: 'CX',
  System: 'SYSTEM'
};

class DrawerAssembly extends React.Component {
  static defaultProps = {
    hide: false,
    error: false,
    properties: [],
    setActive: () => {},
    openOnNew: () => {},
    currentActive: null,
    onDrawerToggle: () => {},
    noResultsProps: {
      noResultstitle: '',
      noResultsdescription: '',
      noResultsPhone: '',
      suggestionLabel: '',
      suggestionList: ''
    },
    drawerSelectProps: {},
    openText: '',
    closeText: '',
    totalProperties: 0,
    favouriteProperties: [],
    bookingBypassReasonId: () => {},
    setMapFilters: () => {},
    setSearchCriteria: () => {},
    mapFilters: null,
    filterLabels: {},
    handlePropertyPaneOpen: () => {},
    showSelectedPropertyPane: false,
    auth: { me: { adminToken: null } },
    loading: false,
    client: null
  };

  static propTypes = {
    analytics: PropTypes.shape({
      trackEvent: PropTypes.func
    }).isRequired,
    hide: PropTypes.bool,
    error: PropTypes.bool,
    properties: PropTypes.arrayOf(PropTypes.shape({})),
    setActive: PropTypes.func,
    openOnNew: PropTypes.func,
    currentActive: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onDrawerToggle: PropTypes.func,
    noResultsProps: PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      phone: PropTypes.string,
      suggestionLabel: PropTypes.string,
      suggestionList: PropTypes.string
    }),
    openText: PropTypes.string,
    closeText: PropTypes.string,
    drawerSelectProps: PropTypes.shape({}),
    totalProperties: PropTypes.number,
    favouriteProperties: PropTypes.arrayOf(PropTypes.shape({})),
    bookingBypassReasonId: PropTypes.func,
    setMapFilters: PropTypes.func,
    setSearchCriteria: PropTypes.func,
    mapFilters: PropTypes.shape({
      filtersContainerState: PropTypes.shape({
        amenities: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            layerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            icon: PropTypes.string,
            selected: PropTypes.bool
          })
        ),
        propertyTypes: PropTypes.arrayOf(PropTypes.shape({})),
        distance: PropTypes.number,
        priceRangeMin: PropTypes.number,
        priceRangeMax: PropTypes.number
      }),
      filtersContainerProps: PropTypes.shape({
        savedDistance: PropTypes.number,
        savedPriceRangeMin: PropTypes.number,
        savedPriceRangeMax: PropTypes.number,
        location: PropTypes.string
      }),
      defaults: PropTypes.shape({
        propertyTypes: PropTypes.arrayOf(PropTypes.shape({})),
        priceRangeMin: PropTypes.number,
        priceRangeMax: PropTypes.number,
        distance: PropTypes.number,
        amenities: PropTypes.arrayOf(PropTypes.shape({}))
      })
    }),
    filterLabels: PropTypes.shape({}),
    handlePropertyPaneOpen: PropTypes.func,
    showSelectedPropertyPane: PropTypes.bool,
    auth: PropTypes.shape({
      me: PropTypes.shape({
        adminToken: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number])
      })
    }),
    loading: PropTypes.bool,
    client: PropTypes.shape({
      query: PropTypes.func
    })
  };

  static getDerivedStateFromProps(props, state) {
    const { mapFilters } = props;

    if (!mapFilters) {
      return null;
    }

    const { filtersContainerState } = state;

    if (!filtersContainerState.initializedProps) {
      const newState = {};
      newState.filtersContainerState = {
        ...filtersContainerState,
        ...mapFilters.filtersContainerState,
        initializedProps: true
      };
      return newState;
    }

    // Check if amenities need to be updated even after initial props are set
    if (
      mapFilters.filtersContainerState?.amenities?.length > 0 &&
      (!filtersContainerState.amenities || filtersContainerState.amenities.length === 0)
    ) {
      return {
        filtersContainerState: {
          ...filtersContainerState,
          amenities: mapFilters.filtersContainerState.amenities
        }
      };
    }

    return null;
  }

  constructor(props) {
    super(props);

    this.state = {
      open: true,
      filtersContainerState: {
        propertyTypes: [],
        showPanel: false,
        selectedOption: undefined,
        distanceUnitAfter: 'km', // hardcoding distance unit for now
        distanceMin: 2,
        distanceMax: 50,
        priceRangeSliderMin: 0,
        priceRangeSliderMax: 2000,
        priceRangeStartIcon: '$', // hardcoding currency sign for now
        showSeeMore: true,
        hideInstantBook: true,
        amenities: []
      },
      disconnectedProperty: false,
      selectedBypassReason: 0,
      connectedBypassReasons: []
    };

    this.onDatesChange = this.onDatesChange.bind(this);
    this.onDistanceChangeSlider = this.onDistanceChangeSlider.bind(this);
    this.onPriceRangeChangeSlider = this.onPriceRangeChangeSlider.bind(this);
    this.onPriceRangeChangeInput = this.onPriceRangeChangeInput.bind(this);
    this.onPriceRangeChangeInputSubmit = this.onPriceRangeChangeInputSubmit.bind(this);
    this.onDistanceChangeInput = this.onDistanceChangeInput.bind(this);
    this.onDistanceChangeInputSubmit = this.onDistanceChangeInputSubmit.bind(this);
    this.onRoomButtonClick = this.onRoomButtonClick.bind(this);
    this.onRoomsValueChange = this.onRoomsValueChange.bind(this);
    this.onPanelButtonClick = this.onPanelButtonClick.bind(this);
    this.onBackdropClick = this.onBackdropClick.bind(this);
    this.onSeeMoreClick = this.onSeeMoreClick.bind(this);
    this.onInstantBookToggle = this.onInstantBookToggle.bind(this);
    this.onAmenityClick = this.onAmenityClick.bind(this);
    this.onClearButtonClick = this.onClearButtonClick.bind(this);
    this.onUpdateFiltersButtonClick = this.onUpdateFiltersButtonClick.bind(this);
    this.onPropertyClick = this.onPropertyClick.bind(this);
  }

  // Drawer closed for mobile and open for desktop on initial mount
  componentDidMount() {
    if (window.innerWidth <= 640) {
      this.setState({ open: false });
    }

    this.getConnectedBypassReasons();

    // Initialize amenities from props if available
    const { mapFilters } = this.props;
    if (mapFilters?.filtersContainerState?.amenities?.length > 0) {
      this.setState(prevState => ({
        ...prevState,
        filtersContainerState: {
          ...prevState.filtersContainerState,
          amenities: mapFilters.filtersContainerState.amenities
        }
      }));
    }
  }

  getConnectedBypassReasons = async () => {
    const { client } = this.props;

    try {
      const response = await client.query({
        query: QUERY_BOOKING_BYPASS_REASON,
        fetchPolicy: 'network-only',
        variables: {
          bypassType: [BookingBypassTypes.Cx]
        }
      });

      this.setState({
        connectedBypassReasons: response.data.getBookingBypassReasonsByType
      });
    } catch (error) {
      const { message, code } = mutationError(error);
      // eslint-disable-next-line
      console.log('message: ', message, ' code: ', code);
    }
  };

  componentDidUpdate(prevProps) {
    const { currentActive } = this.props;

    // Check if currentActive has changed
    if (currentActive !== prevProps.currentActive) {
      this.setCurrentActive(currentActive, prevProps.currentActive);
    }
  }

  setCurrentActive = (propertyId, prev) => {
    if (prev) {
      const prevActive = document.getElementById(`property-${prev}`);

      if (prevActive) {
        prevActive.nextElementSibling.classList.remove('active');
      }
    }

    const elem = document.getElementById(`property-${propertyId}`);

    if (elem) {
      elem.nextElementSibling.classList.add('active');
      elem.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
    }
  };

  setSortOrder = event => {
    const {
      setMapFilters,
      drawerSelectProps: { options }
    } = this.props;

    const newIndex = options.indexOf(event.target.value);

    if (newIndex !== -1) {
      const { analytics } = this.props;

      analytics.trackEvent('result-listing', {
        sectionName: 'Search Results Listing',
        searchResultsListing: 'Sort by',
        sortType: event.target.value.trim()
      });

      const [orderBy, order] = mapSelectValuestoIndex[newIndex];
      setMapFilters({ type: 'updateSort', payload: { orderBy, order } });
    }
  };

  toggleDrawer = () => {
    const { onDrawerToggle, analytics } = this.props;
    const { open } = this.state;

    this.setState(
      {
        open: !open
      },
      () => {
        analytics.trackEvent('listings-panel', {
          sectionName: 'Search Results Map',
          listingPaneState: open ? 'closed' : 'open'
        });
        onDrawerToggle();
      }
    );
  };

  /* ---------------FiltersContainer Handler Functions---------------------*/

  onPanelButtonClick = option => {
    const { filtersContainerState } = this.state;

    this.setState(
      ({ filtersContainerState: { selectedOption } }) => ({
        filtersContainerState: {
          ...filtersContainerState,
          selectedOption: option !== selectedOption ? option : undefined,
          showPanel: option !== selectedOption,
          showBackdrop: option !== selectedOption
        }
      }),
      () => {
        if (option) {
          const { analytics } = this.props;

          analytics.trackEvent('results-listing', {
            sectionName: 'Search Results Listing',
            searchResultsListing: option
          });
        }
      }
    );
    this.forceUpdate();
  };

  onBackdropClick = () => {
    const {
      filtersContainerState,
      filtersContainerState: { numRooms, savedNumRooms }
    } = this.state;

    this.setState({
      filtersContainerState: {
        ...filtersContainerState,
        showBackdrop: false,
        selectedOption: undefined,
        showPanel: false,
        numRooms: numRooms || savedNumRooms
      }
    });
    this.forceUpdate();
  };

  onDistanceChangeSlider = distance => {
    const { filtersContainerState } = this.state;

    this.setState({
      filtersContainerState: {
        ...filtersContainerState,
        distance
      }
    });
    this.forceUpdate();
    this.onUpdateFiltersButtonClick();
  };

  onDistanceChangeInputSubmit = distance => {
    const { filtersContainerState } = this.state;
    if (distance) {
      this.setState(
        {
          filtersContainerState: {
            ...filtersContainerState,
            distance
          }
        },
        () => {
          // State has been updated at this point
          this.onUpdateFiltersButtonClick();
        }
      );
    }
  };

  onPriceRangeChangeSlider = value => {
    const [min, max] = value;
    const { filtersContainerState } = this.state;

    this.setState({
      filtersContainerState: {
        ...filtersContainerState,
        priceRangeMin: min,
        priceRangeMax: max
      }
    });

    this.forceUpdate();
    this.onUpdateFiltersButtonClick();
  };

  onPriceRangeChangeInput = value => {
    const [min, max] = value;
    const { filtersContainerState } = this.state;

    this.setState({
      filtersContainerState: {
        ...filtersContainerState,
        priceRangeMin: min ? +min : min,
        priceRangeMax: max ? +max : max
      }
    });
    this.forceUpdate();
  };

  onPriceRangeChangeInputSubmit = () => {
    this.onUpdateFiltersButtonClick();
  };

  onDistanceChangeInput = (event, typing = false) => {
    const { target: { value } = {} } = event;
    const distance = parseInt(value, 10) || 0;
    const { filtersContainerState } = this.state;

    this.setState({
      filtersContainerState: {
        ...filtersContainerState,
        distance
      }
    });
    if (!typing) {
      this.forceUpdate();
    }
  };

  onDatesChange = ([startDate, endDate]) => {
    const { filtersContainerState } = this.state;
    const { analytics, setSearchCriteria } = this.props;

    const numOfDates = parseDateRangeWithMoment([startDate, endDate]).length - 1;

    const isOverBookingDateRange = numOfDates > 90;

    if (startDate && endDate && !isOverBookingDateRange) {
      this.setState(
        {
          filtersContainerState: {
            ...filtersContainerState,
            startDate,
            endDate,
            showBackdrop: false,
            selectedOption: undefined,
            showPanel: false
          }
        },
        () => {
          analytics.trackEvent('date-select', {
            sectionName: 'Search Results Listing',
            startDate,
            endDate
          });
        }
      );

      return setSearchCriteria({
        type: 'updateDateCriteria',
        payload: { startDate, endDate }
      });
    }
    this.forceUpdate();
    return true;
  };

  onRoomButtonClick = () => {
    const { filtersContainerState } = this.state;

    this.setState(({ filtersContainerState: { numRooms } }) => ({
      filtersContainerState: {
        ...filtersContainerState,
        savedNumRooms: numRooms,
        showPanel: false
      }
    }));
    this.forceUpdate();
  };

  onRoomsValueChange = event => {
    const { filtersContainerState } = this.state;
    let { target: { value } = {} } = event;
    const { analytics, setSearchCriteria } = this.props;

    const isFalsyValue = value !== '' && Number.isNaN(value);
    const isOutOfRange = value < 0 || value > 999;

    if (isFalsyValue || isOutOfRange) {
      value = '1';
    }

    this.setState(
      {
        filtersContainerState: {
          ...filtersContainerState,
          numRooms: value
        }
      },
      () => {
        analytics.trackEvent('rooms-select', {
          sectionName: 'Search Results Listing',
          roomNumbers: value
        });
      }
    );

    if (value) {
      setSearchCriteria({
        type: 'updateRoomCount',
        payload: { count: value }
      });
    }
    this.forceUpdate();
    return undefined;
  };

  /* -------------------Filters Container Handlers end-------------------*/
  /* --------------------FiltersContent Handlers------------------*/
  onSeeMoreClick = () => {
    const { filtersContainerState } = this.state;

    this.setState({
      filtersContainerState: {
        ...filtersContainerState,
        showSeeMore: false
      }
    });
    this.forceUpdate();
  };

  onInstantBookToggle = () => {
    const { filtersContainerState } = this.state;

    this.setState(({ filtersContainerState: { shouldInstantBook } }) => ({
      filtersContainerState: {
        ...filtersContainerState,
        shouldInstantBook: !shouldInstantBook
      }
    }));
    this.forceUpdate();
  };

  onAmenityClick = layerId => {
    const { filtersContainerState } = this.state;

    this.setState(({ filtersContainerState: { amenities } }) => {
      const amenity = amenities.find(({ layerId: propertyLayerId }) => propertyLayerId === layerId);
      const otherAmenities = amenities.filter(({ layerId: propertyLayerId }) => propertyLayerId !== layerId);
      const { selected } = amenity;
      Object.assign(amenity, { selected: !selected });

      return {
        ...filtersContainerState,
        amenities: [...otherAmenities, amenities]
      };
    });
    this.forceUpdate();
  };

  onClearButtonClick = () => {
    const { mapFilters } = this.props;

    if (mapFilters) {
      const {
        mapFilters: {
          defaults: { propertyTypes, priceRangeMin, priceRangeMax, distance, amenities }
        }
      } = this.props;

      this.setState(({ filtersContainerState }) => ({
        filtersContainerState: {
          ...filtersContainerState,
          propertyTypes: propertyTypes.map(p => ({ ...p })), // Avoid default mutation
          amenities: amenities.map(a => ({ ...a })), // Avoid default mutation
          priceRangeMin,
          priceRangeMax,
          distance,
          shouldInstantBook: false
        }
      }));
    }
    this.forceUpdate();
  };

  // mutation map filters
  onUpdateFiltersButtonClick = async () => {
    const {
      filtersContainerState: { distance, priceRangeMin, priceRangeMax, propertyTypes, amenities },
      filtersContainerState
    } = this.state;

    const { mapFilters, analytics, setMapFilters } = this.props;

    this.setState({
      filtersContainerState: {
        ...filtersContainerState,
        showPanel: false,
        showBackdrop: false,
        selectedOption: undefined
      }
    });

    /* Analytics start */
    const filters = {};
    const savedAmenities = mapFilters.filtersContainerState.amenities;
    const savedPropertyTypes = mapFilters.filtersContainerState.propertyTypes;

    const savedDistance = get(mapFilters, 'filtersContainerProps.savedDistance');
    const savedPriceRangeMin = get(mapFilters, 'filtersContainerProps.savedPriceRangeMin');
    const savedPriceRangeMax = get(mapFilters, 'filtersContainerProps.savedPriceRangeMax');
    const location = get(mapFilters, 'filtersContainerProps.location');

    amenities.forEach((amenity, index) => {
      if (Boolean(amenity.selected) !== Boolean(savedAmenities[index].selected)) {
        if (!filters.amenity) {
          filters.amenity = [];
        }

        filters.amenity.push({
          pillText: amenity.label,
          id: amenity.layerId,
          selected: amenity.selected ? 'on' : 'off'
        });
      }
    });

    propertyTypes.forEach((propertyType, index) => {
      if (propertyType.selected !== savedPropertyTypes[index].selected) {
        if (!filters.propertyType) {
          filters.propertyType = [];
        }

        filters.propertyType.push({
          pillText: propertyType.label,
          id: propertyType.layerId,
          selected: propertyType.selected ? 'on' : 'off'
        });
      }
    });

    if (distance !== savedDistance) {
      filters.distance = {
        withinDistance: distance,
        ofLocation: location
      };
    }

    if (priceRangeMax !== savedPriceRangeMax) {
      filters.price = {
        max: priceRangeMax
      };
    }

    if (priceRangeMin !== savedPriceRangeMin) {
      filters.price = { ...filters.price, min: priceRangeMin };
    }

    analytics.trackEvent('filter-change', {
      sectionName: 'Search Results Listing',
      filters,
      filterSubmit: 'update-map'
    });
    /* Analytics end */

    setMapFilters({
      type: 'updateMapFilters',
      payload: {
        mapFilters: { distance, priceRangeMin, priceRangeMax, propertyTypes, amenities }
      }
    });
    this.forceUpdate();
  };

  onPropertyClick = layerId => {
    const { filtersContainerState } = this.state;

    this.setState(({ filtersContainerState: { propertyTypes } }) => ({
      filtersContainerState: {
        ...filtersContainerState,
        propertyTypes: propertyTypes.map(pt => {
          const { selected, layerId: propertyLayerId } = pt;
          if (propertyLayerId === layerId) {
            pt.selected = !selected;
          }
          return pt;
        })
      }
    }));
    this.forceUpdate();
  };

  handleDisconnectedPropertyChange = () => {
    this.setState(prevState => ({
      disconnectedProperty: !prevState.disconnectedProperty
    }));
  };

  // Function to handle dropdown change
  handleBypassReasonChange = event => {
    const { bookingBypassReasonId } = this.props;
    const { disconnectedProperty } = this.state;
    this.setState({
      selectedBypassReason: event.target.value
    });
    if (disconnectedProperty) {
      bookingBypassReasonId(event.target.value);
    }
  };

  /* ------------------------FiltersContent Ends------------------------------*/

  render() {
    const {
      currentActive,
      noResultsProps,
      errorResultsProps,
      drawerSelectProps,
      openText,
      closeText,
      openOnNew,
      properties,
      favouriteProperties,
      startingAtLabel,
      priceFrequencyLabel,
      callForPricingLabel,
      callForAvailability,
      hide,
      noResults,
      error,
      analytics,
      mapFilters,
      filterLabels,
      handlePropertyPaneOpen,
      showSelectedPropertyPane,
      auth,
      loading
    } = this.props;
    const {
      open,
      filtersContainerState,
      disconnectedProperty,
      selectedBypassReason,
      connectedBypassReasons
    } = this.state;
    const {
      me: { adminToken }
    } = auth;

    const { priceRangeMin, priceRangeMax } = filtersContainerState;
    const filteredProperties = properties.filter(
      ({ priceValue }) => !priceValue || (priceValue >= priceRangeMin && priceValue <= priceRangeMax)
    );

    const filteredResults = !!filteredProperties.length;

    return (
      <DrawerContainer open={open} hide={hide} className={error && !open ? 'has-error' : ''}>
        <Drawer
          open={open}
          onToggle={this.toggleDrawer}
          totalProperties={filteredProperties.length}
          openText={openText}
          closeText={closeText}
        >
          <FiltersContainerWrapper>
            {mapFilters ? (
              <FiltersContainer
                labels={filterLabels}
                {...filtersContainerState}
                amenities={
                  filtersContainerState.showSeeMore
                    ? filtersContainerState.amenities?.slice(0, 6)
                    : (filtersContainerState && filtersContainerState.amenities) || []
                }
                {...mapFilters.filtersContainerProps}
                onPriceRangeChangeSlider={value => {
                  this.onPriceRangeChangeSlider(value);
                }}
                onDistanceChangeSlider={value => {
                  this.onDistanceChangeSlider(value);
                }}
                onPriceRangeChangeInput={value => {
                  this.onPriceRangeChangeInput(value);
                }}
                onPriceRangeChangeInputSubmit={() => {
                  this.onPriceRangeChangeInputSubmit();
                }}
                onDistanceChangeInput={event => {
                  this.onDistanceChangeInput(event);
                }}
                onDistanceChangeInputSubmit={value => {
                  this.onDistanceChangeInputSubmit(value);
                }}
                onDatesChangeHook={([startDate, endDate]) => {
                  this.onDatesChange([startDate, endDate]);
                }}
                onAmenityClick={layerId => {
                  this.onAmenityClick(layerId);
                }}
                onInstantBookToggle={() => this.onInstantBookToggle()}
                onSeeMoreClick={() => {
                  this.onSeeMoreClick();
                }}
                onBackdropClick={() => {
                  this.onBackdropClick();
                }}
                onRoomButtonClick={() => {
                  this.onRoomButtonClick();
                }}
                onRoomsValueChange={event => {
                  this.onRoomsValueChange(event);
                }}
                onPanelButtonClick={option => {
                  this.onPanelButtonClick(option);
                }}
                onClearButtonClick={() => {
                  this.onClearButtonClick();
                }}
                onUpdateFiltersButtonClick={() => {
                  this.onUpdateFiltersButtonClick();
                }}
                onPropertyClick={layerId => {
                  this.onPropertyClick(layerId);
                }}
              />
            ) : null}
          </FiltersContainerWrapper>

          {adminToken && (
            <div style={{ margin: '-20px 0 8px 17px' }}>
              <FormElements.Checkbox
                noMargins
                name="disconnectedBooking"
                onChange={this.handleDisconnectedPropertyChange}
                checked={disconnectedProperty}
                value={disconnectedProperty}
                label="This is a disconnected, non-GDS booking"
              />
              <div style={{ paddingRight: '15px', marginTop: '-5px' }}>
                <FormElements.Select
                  noMargins
                  id="disconnectReason"
                  name="disconnectReason"
                  label="Disconnect Reason: (required)"
                  value={selectedBypassReason}
                  error={disconnectedProperty && !selectedBypassReason}
                  errorText="Please select a disconnect reason before proceeding to the next page"
                  onChange={this.handleBypassReasonChange}
                  options={[
                    { label: 'Select a reason', value: 0, disabled: true },
                    ...connectedBypassReasons.map(item => ({
                      label: item.bypassReason,
                      value: item.id
                    }))
                  ]}
                  disabled={false}
                  required
                />
              </div>
            </div>
          )}
          {!error && filteredProperties.length ? (
            <div className="drawer-select-container">
              <DrawerSelect
                {...drawerSelectProps}
                onChange={this.setSortOrder}
                totalProperties={filteredProperties.length}
              />
            </div>
          ) : null}
          {noResults || (!filteredResults && !loading) ? <NoResults {...noResultsProps} analytics={analytics} /> : null}
          {filteredProperties.length && !error && !loading ? (
            <PropertyItemsAssembly
              properties={filteredProperties}
              favouriteProperties={favouriteProperties}
              startingAtLabel={startingAtLabel}
              priceFrequencyLabel={priceFrequencyLabel}
              callForPricingLabel={callForPricingLabel}
              callForAvailability={callForAvailability}
              currentActive={currentActive}
              openOnNew={openOnNew}
              analytics={analytics}
              showSelectedPropertyPane={showSelectedPropertyPane}
              handlePropertyPaneOpen={property => {
                handlePropertyPaneOpen(property);
              }}
              selectedBypassReason={selectedBypassReason}
              disconnectedProperty={disconnectedProperty}
            />
          ) : null}
          {error && <ErroredResults {...errorResultsProps} />}
        </Drawer>
      </DrawerContainer>
    );
  }
}

export default DrawerAssembly;
